import React from 'react';
import Header from '../Components/GlobalComponent/Header';
import Banner from '../Components/ProjectsComponent/Banner';
import Footer from '../Components/GlobalComponent/Footer';
import AllProjects from '../Components/HomeComponent/AllProjects';

const OurProjects = () => {
    return (
        <div>
            <Header />
            <Banner />
            <AllProjects />
            <Footer />
        </div>
    );
};

export default OurProjects;
